<template>
  <div>
    <div class="mb-1">
      <b-button variant="outline-secondary" size="sm" @click="$emit('close')">
        <feather-icon icon="ArrowLeftIcon" size="14" class="mr-25" />
        Voltar
      </b-button>
    </div>

    <!-- Filters -->
    <b-row>
      <b-col cols="12" sm="8">
        <okr-list-filters
          ref="filters"
          :search="search"
          :year="parseInt(year)"
          :quarter="parseInt(quarter)"
          :structure-type="structureType"
          :loadingSearch="loading"
        />
        <div v-if="loading" class="d-flex justify-content-center my-2">
          <b-spinner variant="primary" />
        </div>
        <div v-else>
          <div class="mb-2 mr-2 mt-0">
            <!-- Table Top -->
            <template v-if="structureType != structureTypes.STRUCTURE">
              <okr-save-card
                v-for="item in items"
                :key="item.id"
                :consultant-name="item.name"
                :consultant-role="item.role ? item.role.name : ''"
                :consultant-id="item.id"
                :consultant-img="item.picture_file_url"
                :consultant-contract-type="item.contract_type ? item.contract_type.name : ''"
                :quarter="parseInt(selectedQuarter)"
                :year="parseInt(selectedYear)"
                :okr-total="parseFloat(item.okr_total || 0)"
                :open-form="structureType == structureTypes.OWN? true:false"
                :form-available="!isQuarterClosed"
                :search="search"
              />
            </template>
            <template 
              v-else
              v-for="franchise in franchises"
            >
              <okr-save-card
                :key="`franchise${franchise.franchise_id}`"
                :consultant-name="franchise.franchise_name"
                :consultant-role="''"
                :consultant-id="parseInt(franchise.franchise_id)"
                :consultant-img="undefined"
                :consultant-contract-type="''"
                :quarter="parseInt(selectedQuarter)"
                :year="parseInt(selectedYear)"
                :okr-total="parseFloat(franchise.total_okr || 0)"
                :open-form="false"
                :form-available="false"
                :search="search"
              />
              <template v-for="consultant in franchise.consultants">
                <okr-save-card
                  :key="`franchise${franchise.franchise_id}_consultant${consultant.id}`"
                  :consultant-name="consultant.name"
                  :consultant-role="consultant.role"
                  :consultant-id="parseInt(consultant.id)"
                  :consultant-img="consultant.picture_file_url"
                  :consultant-contract-type="consultant.contract_type"
                  :quarter="parseInt(selectedQuarter)"
                  :year="parseInt(selectedYear)"
                  :okr-total="parseFloat(consultant.okr_total || 0)"
                  :open-form="false"
                  :form-available="!isQuarterClosed"
                  :search="search"
                />
              </template>
            </template>
          </div>
          <div class="mx-2 mb-2">
            <b-row>
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <span class="text-muted"
                  >Exibindo {{ pageItemsFrom }} a {{ pageItemsTo }} de
                  {{ totalItems }} itens</span
                >
              </b-col>
              <!-- Pagination -->
              <b-col
                cols="12"
                sm="6"
                class="d-flex align-items-center justify-content-center justify-content-sm-end"
              >
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalItems"
                  :per-page="itemsPerPage"
                  first-number
                  last-number
                  class="mb-0 mt-1 mt-sm-0"
                  prev-class="prev-item"
                  next-class="next-item"
                  @change="search"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-col>
      <b-col cols="12" sm="4">
        <okr-list-totalizer :loading="loadingTotalizer" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BCardHeader,
  BCardBody,
  BSpinner,
  BFormGroup
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions, mapGetters } from "vuex";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import * as sharedTypes from "@/modules/shared/store/types";
import * as types from "../store/types";
import useAppConfig from "@core/app-config/useAppConfig";
import OkrListFilters from "../components/OkrListFilters.vue";
import OkrListTotalizer from "../components/OkrListTotalizer.vue";
import OkrSaveCard from "../components/OkrSaveCard.vue";
import * as structureTypes from "@/constants/structure_options";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    BFormGroup,
    vSelect,
    OkrListFilters,
    OkrListTotalizer,
    OkrSaveCard
  },
  setup() {
    const { skin } = useAppConfig();

    return { toast: useToast(), skin };
  },
  data() {
    return {
      structureTypes,
      loading: true,
      loadingTotalizer: true,
      currentPage: 1,
      itemsPerPage: 10,
      selectedYear: this.year,
      selectedQuarter: this.quarter
    };
  },
  props: {
    quarter: {
      type: Number,
      required: true,
    },
    year: {
      type: Number,
      required: true,
    },
    structureType: {
      type: String,
      required: false,
      default: structureTypes.STRUCTURE,
    },
  },
  watch: {
    structureType(){
      this.search(1);
    }
  },
  computed: {
    ...mapGetters({
      searchResult: types.PLANNED_OKR_LIST,
      initialItemsPerPage: sharedTypes.INITIAL_ITEMS_PER_PAGE,
      itemsPerPageOptions: sharedTypes.ITEMS_PER_PAGE_OPTIONS
    }),
    items: function () {
      return (this.searchResult?.data || []).filter(Boolean);
    },
    totalItems: function () {
      return this.searchResult?.total || 0;
    },
    pageItemsFrom: function () {
      return this.searchResult?.from || 0;
    },
    pageItemsTo: function () {
      return this.searchResult?.to || 0;
    },
    isQuarterClosed() {
      const now = new Date();
      const currentQuarter = Math.ceil((now.getMonth() + 1) / 3);
      const year = Number(this.selectedYear);
      const quarter = Number(this.selectedQuarter);
      return (
        year < now.getFullYear() ||
        (year === now.getFullYear() && quarter < currentQuarter)
      );
    },
    franchises() {
      const franchises = _(this.items)
        .groupBy('franchise_id')
        .map((objs, key) => ({
          'franchise_id': key,
          'franchise_name': objs[0].franchise_name,
          'total_okr': objs.reduce((sum, obj) => sum + parseFloat(obj.okr_total || 0), 0),
          'consultants': _(objs)
            .map(obj => ({
              id: obj.id,
              name: obj.name,
              role: obj.role?.name || '',
              picture_file_url: obj.picture_file_url,
              contract_type: obj.contract_type?.name || '',
              okr_total: parseFloat(obj.okr_total || 0)
            }))
            .orderBy('name')
            .value()
        }))
        .orderBy([item => (item.franchise_name || '').toLowerCase()], 'asc')
        .value();
      return franchises || []
    }
  },
  mounted() {
    this.itemsPerPage = this.initialItemsPerPage;
  },
  methods: {
    ...mapActions({
      searchOkr: types.SEARCH_PLANNED_OKR_LIST,
      getPlannedOkrTotalizer: types.GET_PLANNED_OKR_TOTALIZER
    }),
    search(currentPage) {
      this.loading = true;
      this.currentPage = Number.isInteger(currentPage) 
        ? currentPage : this.currentPage;
      const { franchise, selectedYear, selectedQuarter } = this.$refs.filters;
      this.selectedYear = selectedYear;
      this.selectedQuarter = selectedQuarter;
      this.searchOkr({
        structure_type: this.structureType,
        year: this.selectedYear,
        quarter: this.selectedQuarter,
        digital_franchises: franchise,
        currentPage: this.currentPage,
        limit: this.itemsPerPage,
      })
        .catch((error) => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: "Oops!",
              text: "Ocorreu um erro ao buscar os OKRs. Entre em contato com o setor de TI.",
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        })
        .finally(() => {
          this.loading = false;
        });
      this.loadingTotalizer = true
      this.getPlannedOkrTotalizer({
        year: this.selectedYear,
        quarter: this.selectedQuarter,
        structure_type: this.structureType,
        digital_franchises: franchise,
      })
        .catch(error => {
          this.toast({
            component: ToastificationContent,
            props: {
              title: 'Oops!',
              text: error?.response?.data?.message || 
                'Ocorreu um erro ao carregar o totalizador do OKR. Entre em contato com o setor de TI.',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
        .finally(() => {
          this.loadingTotalizer = false
        })
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>
